/**
 * Create Pages context for custom hook
 */

import { createContext } from 'react'

const PagesContext = createContext({
  fetchPage: () => {}
})

export default PagesContext
